import { selectTranslations } from 'app/pages/App/slice/selectors';
import React, { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

export enum StatusState {
  SUCCESS = 'S',
  FAILED = 'F',
  SUCCESS2 = 'TC',
  FAILED2 = 'GN',
  PENDING = '',
  DEFAULT = '',
  OUTDATE = 'OUTDATE',
  UNUSED = 'UNUSE',
  USED = 'USED',
  WAITING_CANCEL = 'WAITING_CANCEL',
  CANCELLED = 'CANCELLED',
  WAITING_REFUND = 'WAITING_REFUND',
  REFUND_EXPIRED = 'REFUND_EXPIRED',
  PENDING_CANCELLATION = 'PENDING_CANCELLATION',
  FILE_PENDING = '1',
  FILE_SUCCESS = '2',
  FILE_FAILED = '3',
  REISSUED = 'REISSUED',

  APPOVAL_ORDER_STT_SUCCESS = 'confirmed',
  APPOVAL_ORDER_STT_PENDING = 'pendingConfirmation',
  APPOVAL_ORDER_STT_REFUSE = 'unconfirmed',
  APPOVAL_ORDER_STT_TIMEOUT = 'APPOVAL_ORDER_TIMEOUT',
  APPOVAL_ORDER_STT_CANCELLED = 'cancelled',
}

type StatusComponentProps = {
  status?: StatusState;
  label?: string;
};

const StatusComponent: FC<StatusComponentProps> = ({ status, label }) => {
  const translations = useSelector(selectTranslations);
  const statusStyle = statusStyles(status);
  const statusLabel = useCallback(() => {
    switch (status) {
      case StatusState.SUCCESS:
        return translations?.['b2b.txt.status-success'];
      case StatusState.FAILED:
        return translations?.['b2b.txt.status-failed'];
      case StatusState.UNUSED:
        return translations?.['b2b.txt.status-unused'];
      case StatusState.USED:
        return translations?.['b2b.txt.status-used'];
      case StatusState.OUTDATE:
        return translations?.['b2b.txt.status-outdate'];
      case StatusState.WAITING_CANCEL:
        return translations?.['b2b.txt.ticket-pending-cancel'];
      case StatusState.CANCELLED:
        return translations?.['b2b.txt.ticket-cancelled'];
      case StatusState.WAITING_REFUND:
        return translations?.['b2b.txt.ticket-waiting-to-change'];
      case StatusState.REFUND_EXPIRED:
        return translations?.['b2b.txt.ticket-changed'];
      case StatusState.PENDING_CANCELLATION:
        return translations?.['b2b.txt.ticket-pending-cancel'];
      case StatusState.APPOVAL_ORDER_STT_SUCCESS:
        return translations?.['b2b.approvalStt.success'];
      case StatusState.APPOVAL_ORDER_STT_PENDING:
        return translations?.['b2b.approvalStt.pending'];
      case StatusState.APPOVAL_ORDER_STT_REFUSE:
        return translations?.['b2b.approvalStt.refuse'];
      case StatusState.APPOVAL_ORDER_STT_CANCELLED:
        return translations?.['b2b.approvalStt.cancelled'];
      case StatusState.APPOVAL_ORDER_STT_TIMEOUT:
        return translations?.['b2b.approvalStt.timeout'];
      case StatusState.REISSUED:
        return translations?.['b2b.txt.reissued'];
      default:
        return '';
    }
  }, [status, translations])();
  if (!label && statusLabel === '') return <></>;
  return (
    <StyledStatus style={statusStyle}>{label || statusLabel}</StyledStatus>
  );
};

export default StatusComponent;

const statusStyles = (status?: StatusState) => {
  switch (status) {
    case StatusState.UNUSED:
    case StatusState.SUCCESS:
    case StatusState.SUCCESS2:
    case StatusState.FILE_SUCCESS:
    case StatusState.APPOVAL_ORDER_STT_SUCCESS:
      return {
        background: '#E5FCEF',
        color: '#539A59',
      };
    case StatusState.USED:
    case StatusState.FAILED:
    case StatusState.FAILED2:
    case StatusState.FILE_FAILED:
      return {
        background: '#F2E4DC',
        color: '#BC1823',
      };
    case StatusState.FILE_PENDING:
      return {
        background: '#CAF4FF',
        color: '#03AED2',
      };
    case StatusState.APPOVAL_ORDER_STT_PENDING:
      return {
        background: '#FFF5D9',
        color: '#996B0F',
      };
    case StatusState.OUTDATE:
    case StatusState.PENDING_CANCELLATION:
    case StatusState.CANCELLED:
    case StatusState.APPOVAL_ORDER_STT_REFUSE:
    case StatusState.APPOVAL_ORDER_STT_TIMEOUT:
    case StatusState.APPOVAL_ORDER_STT_CANCELLED:
    default:
      return {
        background: '#E8E8E8',
        color: '#7D7D7D',
      };
  }
};

const StyledStatus = styled.div`
  width: 'auto';
  height: 25px;
  min-width: 100px;
  padding: 1.5px 10px;
  border-radius: 50px;
  font-size: 12px;
  line-height: 22px;
  letter-spacing: 2%;
  line-height: 22px;
  margin: auto;
  white-space: nowrap;
  display: inline-block;
`;
